import { useEffect, useState } from 'react';
import { useStore } from '../../../hooks/Store';
import { useSessionId } from '../../../hooks/SessionId';
import { EMessageDirection, EMessageType, IHistory, IIncommingInfo, useMessages } from '../../../hooks/Messages';
import { getApiUrl, getInstalationId } from '../../../services/CommonFunctions';
import config from '../../../jsons/config.json';

const url = getApiUrl('wss', config.websocket);

//správa WS spojení
function useWS(url: string, headers: any) {
    const [{ socket, close }, setState] = useState<{ socket?: WebSocket, close?: any }>({});

    const createWebSocket = (url: string, headers: any) => {
        console.log('WS: Otevírání...', url);
        const newSocket = new WebSocket(url);
        let timeout: any;
        let closing = false;

        // Přidání posluchače pro událost otevření spojení
        newSocket.addEventListener('open', (event) => {
            console.log('WS: Spojení bylo otevřeno');
            newSocket.send(JSON.stringify({ ...headers, type: 'init' }));
        });

        // Přidání posluchače pro příjem zpráv od serveru
        newSocket.addEventListener('message', (event) => {
            console.log('WS: Přijato: ', event.data);
        });

        // Přidání posluchače pro událost uzavření spojení
        newSocket.addEventListener('close', (event) => {
            console.log('WS: Spojení bylo uzavřeno');

            // Zde můžete implementovat logiku pro opětovné připojení
            clearTimeout(timeout);
            if (!closing) {
                timeout = setTimeout(
                    () => {
                        console.log('WS: Pokus o opětovné připojení...', timeout);
                        createWebSocket(url, headers); // Rekurzivně vytvoří nové spojení
                    },
                    1000
                ); // Počká 1 sekundu a pak se pokusí znovu připojit
                console.log('WS: timeout', timeout);
            }
        });

        // Přidání posluchače pro chyby
        newSocket.addEventListener('error', (event) => {
            console.log('WS: Chyba spojení:', event);
        });

        setState({
            socket: newSocket,
            close: () => {
                console.log('WS: Zavírání...')
                closing = true;
                newSocket.close();
            }
        });
    }

    useEffect(
        () => {
            createWebSocket(url, headers);

            return () => {
                close && close();
            };
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return socket;
}

function WS() {
    const sessionId = useSessionId();
    const { push } = useMessages();
    const { store, setStore } = useStore();

    const socket = useWS(
        url,
        {
            'X-Api-Key': (window as any).stxChatbot.api_key,
            'X-Instalation-Id': getInstalationId(),
            'X-Session-Id': sessionId?.sessionId,
        },
    );

    useEffect(
        () => {
            if (!socket) return;
            console.log('WS: new socket');

            const worker = (event: any) => {
                try {
                    const json = JSON.parse(event.data);

                    switch (json.type) {
                        case 'message':
                            push({
                                direction: EMessageDirection.Incomming,
                                type: EMessageType.History,
                                payload: {
                                    text: json.text
                                } as IHistory
                            });
                            break;
                        case 'info':
                            push({
                                direction: EMessageDirection.Incomming,
                                type: EMessageType.Info,
                                payload: {
                                    text: json.text
                                } as IIncommingInfo
                            });
                            break;
                        case 'expiration':
                            push({
                                direction: EMessageDirection.Incomming,
                                type: EMessageType.Info,
                                payload: {
                                    text: json.text
                                } as IIncommingInfo
                            });
                            setStore({
                                ...store,
                                disableFAQ: true,
                                disableSendButton: true,
                                disableTextInput: true
                            });
                            break;
                    }
                }
                catch (e) { }
            };

            socket.addEventListener('message', worker);

            return () => socket.removeEventListener('message', worker);
        },
        [push, setStore, socket, store]
    );

    return (null);
}

export default WS;
